<template lang="html">
  <div :class="MainAuth.main">
    <div :class="$style.authbox">
      <div class="form" >
        <h2>Insira sua nova senha</h2>
        <el-form :model="ruleForm" size="medium" ref="ruleForm" :rules="rules" v-on:submit.prevent>
          <el-form-item prop="email" label="Email" :error="error.email">
            <el-input auto-complete="true"
                      :class="{'shake animated': animated}"
                      size="large" v-model="ruleForm.email"
                      placeholder="example@gmail.com"
                      type="email" required></el-input>
          </el-form-item>
          <el-form-item prop="password" label="Senha" :error="error.password">
            <el-input auto-complete="true"
                      size="large" v-model="ruleForm.password"
                      type="password" required></el-input>
          </el-form-item>

          <el-form-item prop="password_confirmation" label="Repetir a Senha" :error="error.password_confirmation">
            <el-input size="large" v-model="ruleForm.password_confirmation"
                      type="password" required></el-input>
          </el-form-item>

          <el-form-item style="margin:0;">
            <el-button size="large" :loading="loading" class="raise-primary btn-block" type="primary" native-type="submit" @click.prevent="submitFormChangePAssword('ruleForm')">Trocar Senha</el-button>
          </el-form-item>
          <!--<el-form-item style="text-align: center; padding:15px 0px">-->
          <!--<router-link :to="{name: 'Auth.login'}">Fazer login</router-link>-->
          <!--</el-form-item>-->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {app} from '../../../../config'
import MainAuth from "../MainAuth.scss?module";
import * as services from "../../services";
import {getError, setFormData} from "../../../../plugins/utils";

export default {
  name: 'ChangePassword',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor informe a senha'))
      } else {
        if (this.ruleForm.password_confirmation !== '') {
          this.$refs.ruleForm.validateField('password_confirmation')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Por favor insira a senha novamente'))
      } else if (value !== this.ruleForm.password) {
        callback(new Error('Duas senhas não iguais.'))
      } else {
        callback()
      }
    }
    return {
      app,
      loading: false,
      type: 'password',
      error: {},
      ruleForm: {
        email: '',
        password: '',
        password_confirmation: '',
        token: this.$route.query.token
      },
      rules: {
        email: [
          {required: true, message: 'Por favor informe um e-mail', trigger: 'blur'},
          {type: 'email', message: 'Por favor informe um e-mail valido', trigger: 'blur'}
        ],
        password: [
          { validator: validatePass, trigger: 'blur' }
        ],
        password_confirmation: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      animated: false
    }
  },
  computed: {
    MainAuth() {
      return MainAuth;
    }
  },
  methods: {
    submitFormChangePAssword (ruleForm) {
      this.loading = true
      this.type = 'password'
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          try {
            let response = await services.changePassword(setFormData(this.ruleForm))
            this.loading = false
            await this.$router.push({name: 'auth.login'})
            this.$message({
              showClose: true,
              message: response.message,
              type: 'success'
            })
          } catch (error) {
            this.loading = false
            this.error = getError(error).errors
            this.$message({
              showClose: true,
              message: error.body.message,
              type: 'error'
            })
          }
        } else {
          this.loading = false
        }
      })
    },
    setAnimated () {
      var self = this
      self.animated = true
      setTimeout(function () { self.animated = false }, 1000)
    },
    changeType () {
      if (this.type === 'password') {
        this.type = 'text'
      } else if (this.type === 'text') {
        this.type = 'password'
      }
    }
  },
  created () {
    if (this.$route.query.token === undefined) {
      this.$alert('', 'Não foi encontrado nenhum token valido.', {
        center: true,
        confirmButtonText: 'OK',
        callback: () => {
          this.$router.push({name: 'auth.login'})
        }
      });
    }
  }
}
</script>

<style lang="scss" module>
.authbox {
  max-width: 450px;
  padding: 0 5.5em;
}
.texth1 {
  font-size:2.5rem;
}
@media (max-width: 800px) {
  .authbox {
    max-width: 100%;
    padding: 0 1.5em;
  }
}
</style>
